import { Component, OnInit, EventEmitter } from '@angular/core';
import { UserService } from '../../../common/user.service'
import { FeatureService } from '../../../common/feature.service'
import { PackageService } from '../../../common/package.service'
import { CreditService } from '../../../common/credit.service';
import { CountryService } from '../../../common/country.service';
import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'distributor-feature-form',
  templateUrl: './feature-form.component.html',
  styleUrls: ['./feature-form.component.css','../../../admin/admin.css'],
  providers : [ FeatureService , PackageService, CreditService, UserService, CountryService ]
})
export class DistributorFeatureFormComponent implements OnInit {

  public eventId: any;
  public event: any;
  public packageId: any;
  public feature: any;
  public users = [];
  public onSave = new EventEmitter();
  public onClose = new EventEmitter();
  public spinner: boolean = false;
  public userIndex = 0;
  public currentAnswerId = 0;
  public currentAnswerText = '';
  payType = 'Card';
  creditCard = {
   cardId : 0,
   name : '',
   number : '',
   expMonth : '',
   expYear : '',
   cvv : '',
   type : undefined,
   save : false,
   existing : true
  };
  cards = [];
  featureIndex: any;
    balance=0;

  constructor(private featureService: FeatureService, private packageService: PackageService, private creditService: CreditService, private userService: UserService, private snackBar: MdSnackBar, private countryService: CountryService) { }

  ngOnInit(){
  }

  initiate(){
   this.packageService.getFeatureLimits({packageId:this.packageId}).subscribe(response1 => {
    for(var i=0;i<response1.length;i++)
    if(response1[i].featureId==this.feature.id)
    {
     this.feature.free = parseInt(response1[i].free);
     break;
    }
   });
  }

  changeFeature(){
   this.spinner = true;
   this.creditCard.type = this.cardType();
   this.userService.changeDistributorFeature({ user:this.users[this.userIndex], creditCard:this.creditCard, payType:this.payType, event:this.event }).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     {
      this.snackBar.open('Additional Item Updated Successfully','',{duration:4000});
      this.onSave.emit();
     }
     else
     this.snackBar.open(response.msg,'',{duration:4000});
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
  }

  featureFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(this.users[this.userIndex].eventUser.userFeature.totalPrice>0)
   {
    if(this.payType=='Card' && !this.creditCard.existing)
    {
     if(flag && !this.validateDigit(this.creditCard.number,14,19))
     flag = false;
     if(flag && !this.validateDigit(this.creditCard.cvv,3,4))
     flag = false;
    }
    else if(this.payType=='Card' && this.creditCard.existing)
    {
     if(flag && this.creditCard.cardId<=0)
     flag = false;
    }
   }
   return flag;
  }

  cardType(){
   return this.creditService.parseCardType(this.creditCard.number);
  }

  validateDigit(num,min,max){
   return num.match("^[0-9]{"+min+","+max+"}$");
  }

  validateZip(zip,country){
    return true;
  //  if(country=='Canada')
  //  var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  //  else
  //  var re = /^\d{5}(-\d{4})?$/;
  //  return re.test(zip);
  }

  reset(){
   this.onClose.emit();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/distributor/profile/feature-form/feature-form.component.ts